import { render, staticRenderFns } from "./avatar-edit.vue?vue&type=template&id=2d4551db&scoped=true&"
import script from "./avatar-edit.vue?vue&type=script&lang=js&"
export * from "./avatar-edit.vue?vue&type=script&lang=js&"
import style0 from "./avatar-edit.vue?vue&type=style&index=0&id=2d4551db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4551db",
  null
  
)

export default component.exports